import { useMemo } from 'react';
import { useStore } from 'zustand';

import { store } from './_store.ts';
import { decodeAccessToken } from './utils.ts';

export const useAuthTokens = () => useStore(store, (state) => state.tokens);

export const useDecodedAccessToken = () => {
  const tokens = useAuthTokens();
  const accessToken = tokens?.accessToken; // Make react compiler happy

  return useMemo(() => (accessToken ? decodeAccessToken(accessToken) : undefined), [accessToken]);
};
